<template>
  <article class="page">
    <header class="banner">
      <div class="banner-content">
        <div class="banner-text">
          <p class="banner-title">互联门禁系统</p>
          <p class="banner-desc">助力建设全国统一大市场，优化市场营商环境</p>
        </div>
        <img src="../../assets/img/banner2/icon-access.png" alt="" class="banner-img">
      </div>
    </header>
    <section class="box">
      <mytitle title="对接实施具体步骤" style="margin-top: 64px;"></mytitle>
      <div class="stepbox" style="justify-content: center;">
        <template v-for="(item, index) in stepInfo">
          <div class="stepitembg">
            <template v-if="item.title">
              <div class="overtop"></div>
              <contactUs v-show="item.showContact"></contactUs>
              <div class="stepitem">
                  <div class="step-top">
                      <img src="../../assets/img/step/step-top.svg" alt="" style="width: 133px;height: 70px;">
                  </div>
                  <div class="stepindex">{{ index + 1 }}</div>
                  <div class="stepico">
                      <img src="../../assets/img/step/step-ico.svg" alt="" style="width: 32px;height: 35px;">
                  </div>
                  <div class="stepTitle" v-html="item.title"></div>
                  <div class="stepText" v-html="item.description"></div>
                  <template v-if="item.url">
                    <div style="display: flex;margin-top: 44px;justify-content: space-evenly;padding: 0 10px;">
                      <el-button class="btn2" @click="preview(item.url)">预览</el-button>
                      <el-button type="primary" class="btn1" @click="download(item.url)">下载</el-button>
                    </div>
                  </template>
                  <template v-if="item.contactUs">
                    <div style="display: flex;margin-top: 34px;justify-content: space-evenly;padding: 0 10px;">
                      <el-button class="btn2" style="width: 356px;" @mouseover="item.showContact = true" @mouseleave="item.showContact = false">联系我们</el-button>
                    </div>
                  </template>
              </div>
            </template>
          </div>
        </template>
      </div>
    </section>
  </article>
</template>

<script lang='ts' setup>
import { nextTick, onMounted, ref } from 'vue'
import mytitle from '../../components/title.vue'
import contactUs from '../../components/contactUs.vue'
import { useRoute } from 'vue-router';

const route = useRoute()

onMounted(async () => {
  await nextTick(); // 等待 DOM 更新
  if (route.query.bottom) {
    // 滚动到距离页面顶部800px的位置  
    window.scrollTo({
      top: 900,
      behavior: 'smooth' // 可选，用于平滑滚动  
    });
  } else {
    window.scrollTo(0, 0);
  }
})

const stepInfo = ref([
  {
    title: '阅读接入指南',
    description: '预览、下载《远程异地评标和评标专家库共享技术标准_门禁系统接入指南》',
    url: 'L01远程异地评标和评标专家库共享技术标准_门禁系统接入指南_20250605_1600.pdf',
  },
  {
    title: '与跨省远程异地目录服务<br>组件共同联调测试',
    description: '与跨省远程异地目录服务组件共同联调测试相关接口',
    contactUs: true,
    showContact: false,
  },
])

const preview = (url: string) => {
  window._czc.push(['_trackEvent', '门禁系统', '预览', '门禁系统接入指南预览'])
  window.open(url, '_blank')
}
const download = (url: string) => {
  window._czc.push(['_trackEvent', '门禁系统', '下载', '门禁系统接入指南预览'])
  const link = document.createElement('a')
  link.href = url
  link.download = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/step.scss";

.page {
  .banner {
    width: 100%;
    height: 577px;
    min-width: 1200px;
    background: url('../../assets/img/banner2/registration-bg.png') no-repeat center center/cover;
    padding-top: 116px;
    box-sizing: border-box;
    &-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
    }
    &-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &-title {
      font-size: 36px;
      font-weight: 600;
      line-height: 70px;
      color: #323335;
    }
    &-desc {
      font-size: 18px;
      font-weight: 400;
      line-height: 22px;
      color: #64666B;
    }
    &-img {
      height: 413px;
      margin-top: 40px;
      margin-right: -124px;
    }
  }
  .box {
    height: 536px;
    padding: 1px 0 0;
  }
  .btn1 {
    background-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
    border: none;
  }
  .btn2 {
    color: #3461FF;
    border-color: #3461FF;
    height: 40px;
    width: 50%;
    font-size: 14px;
    border: 1px solid #3461FF;
  }
  .btn2:hover {
    color: #fff;
    background-color: #3461FF;
    border-color: #3461FF;
  }
  .stepitembg {
    height: 290px;
    width: 389px;
    &:nth-child(n + 1) {
      margin-left: 12px;
    }
  }
  .stepitem{
    width: 389px;
  }
}
</style>